import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable()

export class WebinarService {
    readonly baseUrl: string;  // URL to web api

    constructor(private http: HttpClient) {
        this.baseUrl = environment.apiBaseUrl;
    }

    getWebinars() {
        return this.http.get(this.baseUrl + 'dash/webinars');
    }
}
